import React from "react";
import { useAuth } from "../../services/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import {
  setIsDeleteTreeconfirmModalOpen,
  treeHistoryRemove,
  removePlan,
} from "../../reducers/treeMapSlice";

const DeleteConfirmationDialog = (props) => {
  const { user, loading } = useAuth();
  const dispatch = useDispatch();
  const isDeleteTreeconfirmModalOpen = useSelector(
    (state) => state.treeMap.isDeleteTreeconfirmModalOpen,
  );
  const selectedTreeId = useSelector((state) => state.treeMap.selectedTreeId);
  const selectedTreeName = useSelector(
    (state) => state.treeMap.selectedDeleteTreeName,
  );
  const planData = useSelector((state) => state.treeMap.planData);
  let deleteConfirmationModalType = useSelector(
    (state) => state.treeMap.deleteConfirmationModalType,
  );

  const handleDeleteClick = () => {
    (async () => {
      if (!loading) {
        if (user) {
          const userIdToken = await user.getIdToken();
          if (deleteConfirmationModalType === "plan") {
            if (planData && Object.keys(planData).length > 0) {
              let nodeData = Object.keys(planData)[0];
              dispatch(
                removePlan(userIdToken, selectedTreeId, nodeData),
              );
            }
          }
          if (deleteConfirmationModalType === "tree") {
            dispatch(treeHistoryRemove(userIdToken));
          }
        } else {
          // ERROR FOR USER
        }
      }
    })();
  };

  const toggleDialog = () => {
    dispatch(
      setIsDeleteTreeconfirmModalOpen({
        type: deleteConfirmationModalType,
        id: "",
        name: selectedTreeName,
      }),
    );
  };

  return (
    <Dialog
      open={isDeleteTreeconfirmModalOpen}
      onClose={toggleDialog}
      sx={{
        textAlign: "center",
        backdropFilter: "blur(4px)",
        "& .MuiPaper-root": {
          borderRadius: "20px",
          padding: "0px 30px",
        },
        "& .MuiBackdrop-root": {
          backgroundColor: "transparent",
        },
      }}
    >
      <DialogTitle
        sx={{ fontFamily: "ClashDisplay-medium", fontSize: "1.5rem" }}
      >
        {deleteConfirmationModalType === "plan" ? "Delete Plan" : "Delete Tree"}
      </DialogTitle>
      <DialogContent>
        <Typography
          sx={{
            fontFamily: "ClashDisplay-medium",
          }}
        >
          {deleteConfirmationModalType === "plan"
            ? "Are you sure you want to delete the plan?"
            : `Are you sure you want to delete "${selectedTreeName}" tree?`}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", paddingBottom: "20px" }}>
        <Button
          onClick={() => toggleDialog()}
          variant="contained"
          sx={{
            width: "80px",
            background: "white",
            color: "#1D77B7",
            borderRadius: 2,
            border: "1px solid #1D77B7",
            textTransform: "none",
            padding: "5px",
            "&:hover": {
              background: "white",
              boxShadow: "none",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => handleDeleteClick()}
          sx={{
            width: "80px",
            color: "white",
            textTransform: "none",
            backgroundColor: "rgb(244, 67, 54)",
            borderRadius: 2,
            "&:hover": {
              backgroundColor: "rgb(244, 67, 54)",
              boxShadow: "none",
            },
            ml: 3,
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
